import { render, staticRenderFns } from "./ofd_report.vue?vue&type=template&id=50e35e5c&"
import script from "./ofd_report.vue?vue&type=script&lang=js&"
export * from "./ofd_report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports